import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {PasoWizard} from "../../interface/wizard-informacion.types";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ActionField, DataSubForms, SubFormEventsNotifiService} from "@evomatik/evk-forms";
import {formatCurrency} from "@angular/common";

@Component({
    selector: 'lib-simple-section',
    templateUrl: './simple-section.component.html',
    styleUrls: ['./simple-section.component.css']
})
export class SimpleSectionComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() idNegocio: string;

    @Input() typeUI: string;

    @Input() form: FormGroup = new FormGroup({});

    @Input() readOnly: boolean = false;

    @Input() paso: PasoWizard;

    @Input() expediente: any;

    @Input() configExpediente: any;

    @Input() formData: any;

    @Input()
    descargaZipByFolio: boolean;

    @Input()
    skipByVersion: boolean;
    
    @Output() readonly resultObject: EventEmitter<Object> = new EventEmitter<Object>();

    @Output() readonly chagesInSubForms: EventEmitter<Object> = new EventEmitter<Object>();

    doneFormData: Subject<boolean> = new Subject<boolean>();


    actionsField: ActionField[] = [];

    private _unsubscribeAll: Subject<any>;

    constructor(private subFormEventsNotifiService: SubFormEventsNotifiService) {
        this._unsubscribeAll = new Subject();
        this.actionsField.push({name: "convertToUpperCase", accion: this.convertToUpperCase, params: {}});
        this.actionsField.push({name: "copyFirstSixCharacters", accion: this.copyFirstSixCharacters, params: {form: this.form, searchControl: this.searchControl}});
        this.actionsField.push({name: "convertToMoneyFormat", accion: this.convertToMoneyFormat, params: {}});
    }

    ngAfterViewInit(): void {
        this.settearInfo();
    }

    ngOnInit(): void {
        this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
            if (this.form.valid) {
                this.resultObject.next(this.form.value);
            }
        });
    }

    onDoneForm(value: Object) {
        this.resultObject.next(value);
        this.doneFormData.next(true);
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }

    convertToUpperCase(params: {}) {
        const formControl = params['formControl'] as FormControl;
        if (formControl.value) {
            formControl.setValue(formControl.value.toUpperCase());
        }
    }

    copyFirstSixCharacters(params: {}) {
        const controlCurp = params['formControl'] as FormControl;
        const controlRfc = params['searchControl'](params['form'], 'rfc') as FormControl;

        if (controlCurp && controlRfc && !controlRfc.value) {
            controlRfc.setValue(controlCurp.value.toString().substring(0, 10));
        }

    }

    searchControl(formGroup: FormGroup, nombreControl: string): FormControl | null {
        if (formGroup.controls[nombreControl]) {
            return formGroup.controls[nombreControl] as FormControl;
        }
        for (const control in formGroup.controls) {
            if (formGroup.controls[control] instanceof FormGroup) {
                const resultado = this.searchControl(formGroup.controls[control] as FormGroup, nombreControl);
                if (resultado) {
                    return resultado;
                }
            }
        }
        return null;
    }

    convertToMoneyFormat(params: {}) {
        const control = params['formControl'] as FormControl;
        let controlValue: number;
        let numberOfPoints: string [];

        if (control.value) {
            numberOfPoints = control.value.toString().split('.'); // Se divide el string ingresado para validar  que no tenga mas de un punto
            controlValue = control.value.toString()
                .replace(/,/g, '') // Se eliminan comas
                .replace(/\$/g, '') // Se eliminan $
                .replace(/\s/g, ''); // Se eliminan espacios
        }

        const correctFormat = /^\$\s?\d{1,3}(,\d{3})*(\.\d{2})?$/.test(controlValue?.toString());
        const regexWithLetters = /^[a-zA-Z]+$/.test(controlValue?.toString());

        if (regexWithLetters || numberOfPoints.length > 2) {
            control.setErrors({"invalidFormat": "Formato incorrecto"});
        } else if (!correctFormat && !regexWithLetters) {
            const valueFormater = formatCurrency(controlValue, 'es-MX', '', 'MXN', '1.2-2').toString()
                .replace(/\./g, '|')
                .replace(',', '.')
                .replace(/\|/g, ',');
            control.setValue('$ ' + valueFormater);

        }
    }

    settearInfo() {
        this.subFormEventsNotifiService.listObjects$.next(new DataSubForms(false, []))
        this.doneFormData.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            setTimeout(() => {
                this.form.patchValue(this.formData);
                if (this.readOnly) {
                    this.form.disable();
                }
                this.subFormEventsNotifiService.listObjects.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
                    if (response.update) {
                        this.chagesInSubForms.emit(response);
                    }
                });
            }, 3000);
        });
    }

}
